import { createActionCreator } from 'deox';
import { IPool, Sold } from '../../types/reducerTypes';

export const setPoolDetail = createActionCreator(
  'ADD_POOL_DETAIL',
  (resolve) => (pool: IPool) => resolve(pool),
);

export const setTotalSoldPool = createActionCreator(
  'ADD_TOTAL_SOLD',
  (resolve) => (sold: Sold) => resolve(sold),
);

export const setIsPoolSoldOut = createActionCreator(
  'ADD_POOL_SOLD_OUT',
  (resolve) => (isPoolSoldOut: boolean) => resolve(isPoolSoldOut),
);

export const setBchDecimals = createActionCreator(
  'ADD_DECIMALS_BCH',
  (resolve) => (decimals: string) => resolve(decimals),
);
